module.exports = __webpack_public_path__ + "img/thumbnail_GiantPanda_m_normal.6705bcdb.png";